import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'

import filteredObjectsSelector from 'functions/filteredObjectsSelector'
import { combineCampaignEvents } from 'functions/campaign'
import { objectsToArray } from 'functions/utilities'

const sortEvents = events => events.sort((a, b) => {
  const sortA = a.dates && a.dates.date.date ? moment(a.dates.date.date, 'DD/MM/YYYY') : null
  const sortB = b.dates && b.dates.date.date ? moment(b.dates.date.date, 'DD/MM/YYYY') : null

  if (sortA > sortB) return 1
  if (sortA < sortB) return -1
  return 0
})

class EventsWrapper extends React.Component {
  render(){
    const { campaign, events, render } = this.props

    const combinedEvents = combineCampaignEvents(campaign, events)
    const eventArray = objectsToArray(combinedEvents)

    if (!eventArray.length) return null

    return render({
      events: sortEvents(eventArray),
    })
  }
}

EventsWrapper.propTypes = {
  campaign: PropTypes.object.isRequired,
  events: PropTypes.object.isRequired,
  render: PropTypes.func.isRequired,
}

function mapStateToProps(state, props){
  const { campaign } = props

  return {
    events: filteredObjectsSelector(state, 'events', 'campaign_id', campaign.id),
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(EventsWrapper)
